import { useNavigate } from 'react-router';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { EditTeamDto } from '../../../commonTypes/organization.types';
import { useTranslation } from '../../useTranslation';

const useHttpPatchTeam = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string, body: EditTeamDto) => {
        const { exec, abort } = organizationApi.editTeam({
            params: { id },
            body,
            onSuccess: () => {
                toastHandler.push('success', t('team.updateTeamTitle'), t('team.updateTeamMessage_Success'));
                navigate(`/teams/${id}`);
            },
            onError: _ => toastHandler.push('error', t('team.updateTeamTitle'), t('team.updateTeamMessage_Failed')),
        });
        exec();
        return abort;
    };

    return {
        exec,
    };
};

export default useHttpPatchTeam;
